/* eslint-disable import/order */
/* eslint-disable @typescript-eslint/naming-convention */

import React from 'react';

import cn from 'classnames';

import type { ButtonProps } from './Button.types';
import ButtonIcon from './Components/ButtonIcon';
import ButtonLoader from './Components/ButtonLoader';

import styles from './Styles/Button.module.css';
import stylesSize from './Styles/ButtonSizes.module.css';
import stylesVariant from './Styles/ButtonVariants.module.css';

export const Button = React.forwardRef<HTMLAnchorElement | HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      size = 'large',
      color = 'primary',
      variant = 'contained',
      fullWidth,
      leftIcon,
      rightIcon,
      className,
      dataTestId,
      loading,
      Component = 'button',
      darkMode,
      ...restProps
    },
    ref,
  ) => {
    const classNames = cn(
      styles.button,
      stylesVariant[color],
      stylesVariant[variant],
      stylesSize[size],
      {
        [stylesVariant.loading]: loading,
        [styles.fullWidth]: fullWidth,
      },
      darkMode ? stylesVariant.darkMode : '',
      className,
    );

    return (
      <Component data-test-id={dataTestId} {...restProps} className={classNames} ref={ref}>
        {(leftIcon || loading) && (
          <ButtonIcon className={styles.iconLeft} side="left">
            {loading ? <ButtonLoader className={styles.loader} /> : leftIcon}
          </ButtonIcon>
        )}
        {children && <span className={stylesSize.label}>{children}</span>}
        {rightIcon && (
          <ButtonIcon className={styles.iconRight} side="right">
            {rightIcon}
          </ButtonIcon>
        )}
      </Component>
    );
  },
);

Button.displayName = 'Button';

export default Button;
